import React from 'react';
import Button from '@primitives/Button';
import { DownloadIcon } from '@icons';
import cx from 'classnames';
type UploadSampleFileComponentProps = {
  heading: string;
  description: string;
  onSampleFileDownload: () => void;
  className?: string;
};

function uploadSampleFileComponent({
  heading,
  description,
  onSampleFileDownload,
  className = ''
}: UploadSampleFileComponentProps) {
  return (
    <div
      className={cx(
        'flex p-4 rounded-lg bg-[#F7F7F7] flex-col gap-1 justify-center items-start font-[inter]',
        className
      )}
    >
      <div className="text-xs text-[--grayscale-1] font-[inter]"> {heading}</div>
      <div className="text-xs text-[--grayscale-3] font-[inter]"> {description}</div>
      <Button
        onClick={onSampleFileDownload}
        variant="text"
        className="text-center text-[--blue-base]"
        startAdornment={<DownloadIcon color="var(--blue-base)" />}
      >
        Sample file
      </Button>
    </div>
  );
}

export default uploadSampleFileComponent;
